import PropTypes from "prop-types";
import React from "react";

export const SectionHeader = ({ title }) => (
  <tr>
    <th colSpan={2} className="text-uppercase text-muted small pt15 pb5">
      {title}
    </th>
  </tr>
);

SectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
};

export default SectionHeader;
